<template>
  <div class="py-4 container-fluid">
    <!-- RINGKASAN -->
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-3" v-for="(s, i) in summary" :key="'s'+i">
        <div class="card">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">Outstanding {{ s.currency }}</p>
            <h5 class="font-weight-bolder text-danger mb-1">{{ fmt(s.total_outstanding, s.currency) }}</h5>
            <p class="text-xs mb-0">Uang Muka: <b>{{ fmt(s.total_uang_muka, s.currency) }}</b> &nbsp;|&nbsp; Dibayar: <b>{{ fmt(s.total_paid, s.currency) }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">Jumlah Hutang</p>
            <p class="text-xs mb-0">
              <span class="badge badge-sm bg-gradient-secondary">Not Yet Paid: {{ totNotYetPaid }}</span>
              <span class="badge badge-sm bg-gradient-warning ms-1">Partially Paid: {{ totPartiallyPaid }}</span>
              <span class="badge badge-sm bg-gradient-success ms-1">Paid: {{ totPaid }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-4">
              <div class="card-header pb-0">
                <h6>Account Payable (Hutang Vendor)</h6>
                <p class="text-xs mb-0">Hutang diakui otomatis dari penerimaan barang (Stock In), proporsional qty diterima.</p>
              </div>
            </div>
            <div class="col-lg-5">
              <input type="text" class="form-control mt-3" placeholder="Search by PO No." v-model="search.po_no" v-on:keyup.enter="quickSearch()">
            </div>
            <div class="col-lg-3">
              <argon-button style="margin-left: 60px;" class="mt-4" variant="gradient" color="secondary" size="sm" @click="formFilter.show = true"><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PO No.</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Vendor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Nilai PO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Hutang Diakui</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Dibayar</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Outstanding</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jatuh Tempo</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center"><span class="badge badge-sm bg-gradient-primary">{{ row.po_no }}</span></td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold">{{ row.company_name }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.po_total, row.currency) }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.amount, row.currency) }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.amount_paid, row.currency) }}</span></td>
                    <td class="align-middle text-end">
                      <span class="text-danger text-xs font-weight-bold" v-if="Number(row.outstanding_amount) >= 0">{{ fmt(row.outstanding_amount, row.currency) }}</span>
                      <span class="badge badge-sm bg-gradient-info" v-else title="Dibayar melebihi hutang yang sudah diakui">Uang Muka {{ fmt(-row.outstanding_amount, row.currency) }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success" v-if="row.status == 'Paid'">Paid</span>
                      <span class="badge badge-sm bg-gradient-warning" v-else-if="row.status == 'Partially Paid'">Partially Paid</span>
                      <span class="badge badge-sm bg-gradient-secondary" v-else>Not Yet Paid</span>
                    </td>
                    <td class="align-middle text-center"><span class="text-secondary text-xs font-weight-bold" v-if="row.date_payment">{{ moment(row.date_payment).locale('id').format('LL') }}</span></td>
                    <td><i class="fa fa-eye fa-sm" aria-hidden="true" title="Lihat detail hutang" style="cursor: pointer; margin-right: 20px;" @click="openDetail(row.id)"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
            <div class="float-right">
              <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL DETAIL ======= -->
  <div class="container">
    <vue-final-modal v-model="formDetail.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">Detail Hutang {{ detail.data.po_no }} - {{ detail.data.company_name }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formDetail.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <div class="bank-box" v-if="detail.data.bank_account_no">
          <i class="fas fa-university"></i> Rekening vendor: <b>{{ detail.data.bank_name }} {{ detail.data.bank_branch }}</b> &middot; <b>{{ detail.data.bank_account_no }}</b>
          <span v-if="detail.data.bank_account_name"> a.n. {{ detail.data.bank_account_name }}</span>
        </div>
        <div class="bank-box bank-empty" v-else-if="detail.data.po_no"><i class="fas fa-exclamation-triangle"></i> Rekening bank vendor belum diisi di Vendor Management</div>
        <div class="row text-sm mb-3">
          <div class="col-md-3">Nilai PO<br><b>{{ fmt(detail.data.po_total, detail.data.currency) }}</b></div>
          <div class="col-md-3">Hutang Diakui<br><b>{{ fmt(detail.data.amount, detail.data.currency) }}</b></div>
          <div class="col-md-3">Dibayar<br><b>{{ fmt(detail.data.amount_paid, detail.data.currency) }}</b></div>
          <div class="col-md-3">{{ Number(detail.data.outstanding_amount) >= 0 ? 'Outstanding' : 'Uang Muka' }}<br><b>{{ fmt(Math.abs(detail.data.outstanding_amount), detail.data.currency) }}</b></div>
        </div>

        <h6 class="text-sm">Penerimaan Barang</h6>
        <table class="table table-sm align-items-center mb-3">
          <thead><tr>
            <th class="text-xxs text-secondary">Item</th><th class="text-xxs text-secondary text-center">Qty PO</th><th class="text-xxs text-secondary text-center">Diterima</th><th class="text-xxs text-secondary text-center">Status</th>
          </tr></thead>
          <tbody>
            <tr v-for="(item, i) in detail.items" :key="'i'+i">
              <td class="text-xs">{{ item.no_item }} - {{ item.part_name }}</td>
              <td class="text-xs text-center">{{ item.qty }} {{ item.unit }}</td>
              <td class="text-xs text-center">{{ item.status == 'Already Received' ? item.qty : item.qty_received }}</td>
              <td class="text-xs text-center">{{ item.status }}</td>
            </tr>
          </tbody>
        </table>

        <h6 class="text-sm">Termin Pembayaran</h6>
        <p class="text-xs" v-if="detail.terms.length == 0">PO ini tidak punya termin pembayaran, pembayaran dicatat langsung di bawah.</p>
        <table class="table table-sm align-items-center mb-3" v-else>
          <thead><tr>
            <th class="text-xxs text-secondary">Termin</th><th class="text-xxs text-secondary text-center">%</th><th class="text-xxs text-secondary text-end">Nilai</th><th class="text-xxs text-secondary text-end">Dibayar</th><th class="text-xxs text-secondary text-center">Jatuh Tempo</th><th class="text-xxs text-secondary text-center">Status</th>
          </tr></thead>
          <tbody>
            <tr v-for="(term, i) in detail.terms" :key="'t'+i">
              <td class="text-xs">{{ term.term_payment }}</td>
              <td class="text-xs text-center">{{ term.percentage }}%</td>
              <td class="text-xs text-end">{{ fmt(term.term_amount, detail.data.currency) }}</td>
              <td class="text-xs text-end">{{ fmt(term.amount_paid, detail.data.currency) }}</td>
              <td class="text-xs text-center">{{ term.date_payment ? moment(term.date_payment).locale('id').format('LL') : '-' }}</td>
              <td class="text-xs text-center">{{ term.status }}</td>
            </tr>
          </tbody>
        </table>

        <h6 class="text-sm">Riwayat Pembayaran</h6>
        <p class="text-xs" v-if="detail.history.length == 0">Belum ada pembayaran.</p>
        <table class="table table-sm align-items-center mb-3" v-else>
          <thead><tr>
            <th class="text-xxs text-secondary">Tanggal</th><th class="text-xxs text-secondary">Termin</th><th class="text-xxs text-secondary text-end">Jumlah</th><th class="text-xxs text-secondary">Metode / Ref</th><th class="text-xxs text-secondary">Oleh</th>
          </tr></thead>
          <tbody>
            <tr v-for="(h, i) in detail.history" :key="'h'+i">
              <td class="text-xs">{{ moment(h.payment_date).locale('id').format('LL') }}</td>
              <td class="text-xs">{{ h.term_payment || '-' }}</td>
              <td class="text-xs text-end">{{ fmt(h.payment_amount, detail.data.currency) }}</td>
              <td class="text-xs">{{ h.payment_method }} {{ h.reference_no ? '/ '+h.reference_no : '' }}</td>
              <td class="text-xs">{{ h.created_by }}</td>
            </tr>
          </tbody>
        </table>

        <!-- bayar langsung hanya untuk PO tanpa termin; PO bertermin dibayar di Jadwal Pembayaran -->
        <div v-if="detail.terms.length == 0 && Number(detail.data.amount_paid) < Number(detail.data.po_total)">
          <h6 class="text-sm">Catat Pembayaran</h6>
          <div class="row">
            <div class="col-md-3">
              <label class="form-control-label">Jumlah <span style="color: red;">*</span></label>
              <input type="number" step="0.01" class="form-control" v-model="pay.payment_amount">
            </div>
            <div class="col-md-3">
              <label class="form-control-label">Tanggal Bayar <span style="color: red;">*</span></label>
              <input type="date" class="form-control" v-model="pay.payment_date">
            </div>
            <div class="col-md-2">
              <label class="form-control-label">Metode</label>
              <select class="form-select" v-model="pay.payment_method">
                <option v-for="(m, i) in paymentMethods" :key="i" :value="m">{{ m }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-control-label">No. Referensi</label>
              <input type="text" class="form-control" v-model="pay.reference_no">
            </div>
            <div class="col-md-2">
              <argon-button style="margin-top: 32px;" variant="gradient" color="success" size="sm" @click="payDirect()" :disabled="onLoading">
                <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i></span>
                <span v-else>Bayar</span>
              </argon-button>
            </div>
          </div>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Filter</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <label class="form-control-label mt-3">Status</label>
        <select class="form-select" v-model="search.status">
          <option value="">All</option>
          <option value="Not Yet Paid">Not Yet Paid</option>
          <option value="Partially Paid">Partially Paid</option>
          <option value="Paid">Paid</option>
          <option value="Uang Muka">Uang Muka</option>
        </select>
        <label class="form-control-label mt-3">Vendor</label>
        <input type="text" class="form-control" placeholder="Nama Vendor" v-model="search.vendor_name">
        <label class="form-control-label mt-3">Mata Uang</label>
        <select class="form-select" v-model="search.currency">
          <option value="">All</option>
          <option value="IDR">IDR</option>
          <option value="USD">USD</option>
          <option value="CNY">CNY</option>
        </select>
      </div>
      <div class="row float-right mt-3">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="search = {po_no: '', vendor_name: '', status: '', currency: ''}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="quickSearch()">Filter</argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccAccountPayable",
  components: {
    ArgonButton,
    VueFinalModal,
    BasePagination,
  },
  data() {
    return {
      moment: moment,
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      summary: [],
      totNotYetPaid: 0,
      totPartiallyPaid: 0,
      totPaid: 0,
      formFilter: { show: false },
      formDetail: { show: false },
      detail: { data: {}, items: [], terms: [], history: [] },
      pay: {},
      paymentMethods: ['Transfer', 'Cash', 'Giro', 'Cek'],
      onLoading: false,
      search: { po_no: '', vendor_name: '', status: '', currency: '' },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value, currency) {
      return (currency || 'IDR')+' '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.accountPayable({ po_no: context.search.po_no, vendor_name: context.search.vendor_name, status: context.search.status, currency: context.search.currency, page: context.pagination.page })).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
          context.summary               = response.data.data.summary;
          context.totNotYetPaid         = response.data.data.totNotYetPaid;
          context.totPartiallyPaid      = response.data.data.totPartiallyPaid;
          context.totPaid               = response.data.data.totPaid;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() {
          context.formFilter.show = false;
      })
      .call()
    },
    quickSearch() {
      this.pagination.page = 1;
      this.get();
    },
    openDetail(id) {
      let context = this;
      Api(context, accounting.showAccountPayable(id)).onSuccess(function(response) {
          context.detail = response.data.data;
          context.pay    = {
            payment_amount: Math.max(0, Number(context.detail.data.amount) - Number(context.detail.data.amount_paid)).toFixed(2),
            payment_date:   moment().format('YYYY-MM-DD'),
            payment_method: 'Transfer',
            reference_no:   '',
          };
          context.formDetail.show = true;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    payDirect() {
      let context = this;
      if (!(Number(context.pay.payment_amount) > 0) || !context.pay.payment_date) {
        return alert('Jumlah dan Tanggal Bayar wajib diisi');
      }
      context.onLoading = true;
      Api(context, accounting.payAccountPayable(context.detail.data.id, context.pay)).onSuccess(function() {
          context.notify('Pembayaran Berhasil Dicatat', 'success')
          context.openDetail(context.detail.data.id);
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Pembayaran Gagal Dicatat', 'error')
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call();
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 3000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}

.bank-box { font-size: 0.8rem; background: #eef6ff; border: 1px solid #cfe3ff; border-radius: 8px; padding: 8px 12px; margin-bottom: 12px; color: #344767; }
.bank-box i { color: #5e72e4; margin-right: 4px; }
.bank-empty { background: #fff8e6; border-color: #ffe2a8; color: #8a6100; }
.bank-empty i { color: #e0a100; }
</style>
